import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";

export const Preloader = ({ onComplete }) => {
  const preloaderRef = useRef(null);
  const logoRef = useRef(null);
  const progressRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        // Slide up animation
        gsap.to(preloaderRef.current, {
          yPercent: -100,
          duration: 0.8,
          ease: "power4.inOut",
          onComplete: onComplete
        });
      }
    });

    // Logo animation
    tl.from(logoRef.current, {
      scale: 0.8,
      opacity: 0,
      duration: 0.5,
      ease: "power3.out"
    });

    // Progress animation
    const progressAnimation = { value: 0 };
    tl.to(progressAnimation, {
      value: 100,
      duration: 1.5,
      ease: "power2.inOut",
      onUpdate: () => {
        setProgress(Math.round(progressAnimation.value));
      }
    }, "-=0.3");

    // Logo pulse
    tl.to(logoRef.current, {
      scale: 1.05,
      duration: 0.2,
      ease: "power2.out",
      yoyo: true,
      repeat: 1
    }, "-=0.3");

  }, [onComplete]);

  return (
    <div
      ref={preloaderRef}
      className="fixed inset-0 z-[10000] bg-obsidian flex flex-col items-center justify-center"
    >
      {/* Logo */}
      <div ref={logoRef} className="mb-8">
        <span className="font-heading text-6xl md:text-8xl font-bold text-concrete tracking-tight">
          LTVT
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-48 h-px bg-concrete/20 relative overflow-hidden">
        <div
          ref={progressRef}
          className="absolute top-0 left-0 h-full bg-concrete transition-all duration-100"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Progress number */}
      <div className="mt-4 text-concrete/60 text-sm font-mono">
        {progress}%
      </div>
    </div>
  );
};

export default Preloader;
